// Generated by scripts/photos-build.mjs. Do not edit.
// Source of truth is photos/manifest.json; group and name them in the
// add-photos tool, then run `npm run photos`.

export interface PhotoCollection {
  id: string
  title: string
  /** Slugs in manifest order, which is the order the viewer steps through. */
  slugs: string[]
}

export const collections: PhotoCollection[] = [
  {
    id: 'canyon-country',
    title: 'Canyon Country',
    slugs: [
      '2026-09-04-01',
      '2026-08-22-01',
      '2026-09-06-01',
      '2026-09-05-01',
      '2026-09-12-01',
      '2026-08-29-01',
      '2026-09-05-03',
      '2026-09-04-02',
      '2026-08-21-02',
      '2026-08-21-01',
      '2026-08-22-03',
      '2026-08-30-01',
      '2026-09-05-02',
      '2026-08-22-02',
      '2026-08-30-02',
      '2026-09-06-02',
      '2024-05-21-01',
      '2024-05-20-01',
      '2022-10-10-01',
      '2022-10-13-01',
      '2024-05-20-02',
    ],
  },
  {
    id: 'black-hills',
    title: 'Black Hills and Bighorns',
    slugs: [
      '2026-05-30-03',
      '2026-05-30-01',
      '2026-05-23-01',
      '2026-05-14-01',
      '2026-06-13-01',
      '2026-06-05-01',
      '2026-06-05-02',
      '2026-05-23-02',
      '2026-05-30-02',
      '2022-09-18-01',
    ],
  },
  {
    id: 'iowa-backroads',
    title: 'Backroads',
    slugs: [
      '2026-06-19-01',
      '2026-07-22-01',
      '2026-08-11-01',
      '2026-08-11-03',
      '2026-07-25-01',
      '2026-07-23-01',
      '2024-05-05-01',
      '2026-07-23-02',
      '2026-08-11-02',
      '2021-10-15-01',
    ],
  },
  {
    id: 'east-woods',
    title: 'The Smokies',
    slugs: ['2026-07-08-02', '2025-08-30-01', '2026-07-08-01', '2025-08-30-02'],
  },
  {
    id: 'home-place',
    title: 'Home',
    slugs: [
      '2025-04-29-01',
      '2025-11-11-01',
      '2024-05-03-01',
      '2024-05-03-02',
      '2024-05-16-01',
    ],
  },
  {
    id: 'gulf-coast',
    title: 'Texas Gulf Coast',
    slugs: ['2025-02-26-04', '2025-02-26-03', '2025-02-26-01', '2025-02-26-02'],
  },
  {
    id: 'san-juans',
    title: 'San Juans Just Before Spring',
    slugs: ['2025-03-07-02', '2025-03-02-01', '2025-03-07-01'],
  },
]
